<section class="content d-flex">
    <div class="content-block ">
        <div class="tab-content d-flex flex-column flex-grow-1 ">
            <div class="heading-2">Information</div>
            <div class="sub-text ">Update your information</div>
            <div class="item-content flex-grow-1">
                <form action="" [formGroup]="userAccount" (ngSubmit)="onSubmit()">
                    <span class="profile-box">
                        <div class="profile-img mt-3 mt-lg-4" *ngIf="!imagePath"
                            [appBackgroundImg]="profilePicture" [iType]="'company_logo'">
                            <ng-container *ngTemplateOutlet="chooseFile"></ng-container>
                        </div>
                        <!-- display the image selected through choose file -->
                        <div class="profile-img mt-3 mt-lg-4" *ngIf="imagePath"
                            [style.backgroundImage]="'url('+ imagePath +')'">
                            <ng-container *ngTemplateOutlet="chooseFile"></ng-container>
                        </div>
                    </span>
                    <ng-template #chooseFile>
                        <div class="profile-edit-icon d-flex align-items-center justify-content-center"
                            (click)="fileInput.click()">
                            <i class="material-icons">mode_edit</i>
                            <input #fileInput type="file" formControlName="profile_picture"
                                (change)="onProfilePicChange($event)" accept=".png, .jpg, .jpeg" style="display:none" />
                        </div>
                    </ng-template>
                    <div class="row d-flex align-items-center justify-content-center mt-4" *ngIf="userInfo.group_type=='individual'||userInfo.group_type=='manager'">
                        <div class="col-md-6 mt-2 mt-lg-3">
                            <label for="">First Name</label>
                            <div class="form-input">
                                <input type="text" class="form-control" placeholder="Enter First Name"
                                    formControlName="first_name">
                            </div>
                            <mat-error *ngIf="isControlHasError('first_name','required')"> {{"First Name is required"|translate}}</mat-error>
                        </div>
                    </div>
                    <div class="row d-flex align-items-center justify-content-center" *ngIf="userInfo.group_type=='individual'||userInfo.group_type=='manager'">
                        <div class="col-md-6 mt-2 mt-lg-3">
                            <label for="">Last Name</label>
                            <div class="form-input">
                                <input type="text" class="form-control" placeholder="Enter Last Name"
                                    formControlName="last_name">
                            </div>
                            <mat-error *ngIf="isControlHasError('last_name','required')"> Last Name is required</mat-error>
                        </div>
                    </div>
                    <div class="row d-flex align-items-center justify-content-center "*ngIf="userInfo.group_type=='company'">
                        <div class="col-md-6 mt-2 mt-lg-3">
                            <label for="">Company Name</label>
                            <div class="form-input">
                                <input type="text" class="form-control" placeholder="Enter Company Name"
                                    formControlName="company_name">
                            </div>
                            <mat-error *ngIf="isControlHasError('company_name','required')"> {{"Company Name is required"|translate}}</mat-error>
                        </div>
                    </div>
                    <div class="row d-flex align-items-center justify-content-center">
                        <div class="col-md-6 mt-2 mt-lg-3">
                            <label for="">Email</label>
                            <div class="form-input">
                                <input type="text" class="form-control" placeholder="Enter Email"
                                    formControlName="email">
                            </div>
                            <mat-error *ngIf="isControlHasError('email','required')"> Email is required</mat-error>
                            <mat-error *ngIf="isControlHasError('email','email')"> Please enter valid email</mat-error>
                        </div>
                    </div>

                    <div class="row d-flex align-items-center justify-content-center">
                        <div class="col-md-6 mt-2 mt-lg-3">
                            <label for="">Phone Number</label>
                            <div class="form-input">
                                <input type="text" class="form-control" placeholder="Enter Phone Number" formControlName="phone_number">
                                <!-- <img src="assets/images/icons/phone.svg" class="img-fluid material-icons"> -->
                            </div>
                            <mat-error *ngIf="isControlHasError('phone_number','pattern')"> Please enter valid phone number</mat-error>
                        </div>
                    </div>
                    <div class="row d-flex align-items-center justify-content-center" *ngIf="userInfo.group_type=='company'">
                        <div class="col-md-6 mt-2 mt-lg-3">
                            <label for="">About Us</label>
                            <div class="form-input">
                                <input type="text" class="form-control" placeholder="Enter About Us"  formControlName="about_us">
                                <!-- <img src="assets/images/icons/phone.svg" class="img-fluid material-icons"> -->
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex align-items-center justify-content-center" *ngIf="userInfo.group_type=='company'">
                        <div class="col-md-6 mt-2 mt-lg-3">
                            <label for="">Website URL</label>
                            <div class="form-input">
                                <input type="text" class="form-control" placeholder="Enter Website Url" formControlName="website_url">
                                <!-- <img src="assets/images/icons/phone.svg" class="img-fluid material-icons"> -->
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-5  flex-wrap">
                        <!-- <button type="button"
                            class="btn c-btn btn-outline-primary outline-btn justify-content-center d-flex mt-3  align-items-center v-btn me-2">
                            {{"Cancel" |translate}}</button> -->
                        <button mat-raised-button color="primary" class="primary-btn c-btn no-sh-btn mt-3"
                            type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>
<app-loading-spinner></app-loading-spinner>